export const languageDictionary = {
  pl: {
    pl: 'Polski',
    hu: 'Lengyel',
    sk: 'Poľština',
    cs: 'Polština',
    en: 'Polish',
    ro: 'Poloneză',
    hr: 'Poljski',
  },

  en: {
    pl: 'Angielski',
    hu: 'Angol',
    sk: 'Angličtina',
    cs: 'Angličtina',
    en: 'English',
    ro: 'Engleză',
    hr: 'Engleski',
  },

  de: {
    pl: 'Niemiecki',
    hu: 'Német',
    sk: 'Nemčina',
    cs: 'Němčina',
    en: 'German',
    ro: 'Germană',
    hr: 'Njemački',
  },

  es: {
    pl: 'Hiszpański',
    hu: 'Spanyol',
    sk: 'Španielčina',
    cs: 'Španělština',
    en: 'Spanish',
    ro: 'Spaniolă',
    hr: 'Španjolski',
  },

  fr: {
    pl: 'Francuski',
    hu: 'Francia',
    sk: 'Francúzsky',
    cs: 'Francouzština',
    en: 'French',
    ro: 'Franceză',
    hr: 'Francuski',
  },

  it: {
    pl: 'Włoski',
    hu: 'Olasz',
    sk: 'Taliančina',
    cs: 'Italština',
    en: 'Italian',
    ro: 'Italiană',
    hr: 'Talijanski',
  },

  no: {
    pl: 'Norweski',
    hu: 'Norvég',
    sk: 'Nórsky',
    cs: 'Norský',
    en: 'Norwegian',
    ro: 'Norvegian',
    hr: 'Norveški',
  },

  sv: {
    pl: 'Szwedzki',
    hu: 'Svéd',
    sk: 'Švédsky',
    cs: 'Švédský',
    en: 'Swedish',
    ro: 'Suedez',
    hr: 'Švedski',
  },

  nl: {
    pl: 'Niderlandzki',
    hu: 'Holland',
    sk: 'Holandčina',
    cs: 'Nizozemština',
    en: 'Dutch',
    ro: 'Olandeză',
    hr: 'Nizozemski',
  },

  ru: {
    pl: 'Rosyjski',
    hu: 'Orosz',
    sk: 'Ruský',
    cs: 'Ruština',
    en: 'Russian',
    ro: 'Rusă',
    hr: 'Ruski',
  },

  cs: {
    pl: 'Czeski',
    hu: 'Cseh',
    sk: 'Český',
    cs: 'Čeština',
    en: 'Czech',
    ro: 'Cehă',
    hr: 'Češki',
  },

  sk: {
    pl: 'Słowacki',
    sk: 'Slovenský',
    cs: 'Slovák',
    en: 'Slovak',
    hu: 'Szlovák',
    ro: 'Slovacă',
    hr: 'Slovački',
  },

  pt: {
    pl: 'Portugalski',
    sk: 'Portugalčina',
    cs: 'Portugalština',
    en: 'Portuguese',
    hu: 'Portugál',
    ro: 'Portugheză',
    hr: 'Portugalski',
  },

  hu: {
    pl: 'Węgierski',
    cs: 'Maďarský',
    sk: 'Maďarský',
    hu: 'Magyar',
    en: 'Hungarian',
    ro: 'Maghiară',
    hr: 'Mađarski',
  },

  el: {
    pl: 'Grecki',
    cs: 'Recký',
    sk: 'Grécky',
    hu: 'Görög',
    en: 'Greek',
    ro: 'Greacă',
    hr: 'Grčki',
  },

  hr: {
    pl: 'Chorwacki',
    hu: 'Horvát',
    sk: 'Chorvátsky',
    cs: 'Chorvatština',
    en: 'Croatian',
    ro: 'Croată',
    hr: 'Hrvatski',
  },
};
